import { render, staticRenderFns } from "./layouts.eshop.db49458c.vue?vue&type=template&id=3546c6a8"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports